<template>
    <div class="employeeDetailsVue">
        <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-5">
                    <p class="u-back"><a href="javascript: void(0)" @click="backToEmployeeList()"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</a></p>
                </div>
                <div class="col-md-7 text-right">
                    <ul class="o-filter-area">
                        <li :class="{'isDisabled':!getPower('editEmployee')}"><a href="javascript: void(0)" @click="editEmployee()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> {{ $t('edit_employee') }}</a></li>
                        <li :class="{'isDisabled':!getPower('deleteEmployee')}"><a href="javascript: void(0)" :class="(employeeId == clientEmployeeId)?'disabled':''" @click="deleteEmployees()" class="c-common-btn c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> {{ $t('delete_employee') }}</a></li>
                    </ul>
                </div>
            </div>
            <div class="row c-responsive-fixwidth">
                <div class="col-md-6">
                    <div class="employee-summary-profile employee-summary-profile--inline">
                        <div class="c-user__profile-pic u-mar-right-10">
                            <!-- <img src="static/assets/images/user2.jpg" /> -->
                            <img v-if="detailEmployee.employable ? detailEmployee.employable.image != '' && detailEmployee.employable.image != 'NULL':''" :src="(detailEmployee.employable.image)"  id='img-upload'/>
                            <img v-if="detailEmployee.employable ? detailEmployee.employable.image == '' || detailEmployee.employable.image == 'NULL':''" src="static/assets/images/user1.png" id='img-upload' />
                        </div>
                        <!-- <div class="c-user__profile-details"> -->
                        <div class="summary-info o-schedule-user">
                            <h4 class="h1">
                                {{detailEmployee.employable ? (detailEmployee.employable.first_name+" "+detailEmployee.employable.last_name): "NA"}} {{detailEmployee.employable && detailEmployee.employable.display_name && detailEmployee.employable.display_name != 'null' ? '(' + (detailEmployee.employable.display_name) + ')': ""}}
                            </h4>
                            <!-- <p>{{ $t('account_type') }}: {{detailEmployee.employable_type}}</p> -->
                            <div>
                                <p v-if="employeePhone.length > 0">
                                    <span v-for="(phone,index) in employeePhone" :key="index" v-if="phone.phone_number && phone.phone_number != '' && phone.phone_number !='0'">
                                        <span v-if="phone.label && (phone.label=='Home phone' || 'Home Phone' || 'Cell phone' || 'Cell Phone')">
                                            {{ $t(phone.label) }}:
                                        </span> 
                                        <span v-else>{{ phone.label }}:</span>
                                        <!-- <span class="header-value">{{ phone.phone_number }}</span> -->
                                        <a :href="'tel:'+getClientContactFormat(phone.phone_number)" class="header-value phone-number-display">
                                            {{ phone.phone_number ? getClientContactFormat(phone.phone_number) : '' }}
                                        </a>
                                    </span>
                                </p>
                                <p v-else>
                                    <span>{{ $t('home_phone') }}:</span><span class="header-value">NA</span>
                                    <span>{{ $t('cell_phone') }}:</span><span class="header-value">NA</span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <span>Status:</span>
                                    <span class="header-value">{{ detailEmployee.employee_status?detailEmployee.employee_status.name:'NA' }},</span>
                                    <span>Seniority:</span>
                                    <span class="header-value">{{ detailEmployee.seniority?detailEmployee.seniority:'NA' }}</span>
                                </p>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

            <!-- /Heading Section -->

            <!-- Main Body Content area -->
            <!-- Tab nav area -->
            <div class="c-common-space c-responsive-fixwidth">
                <div class="o-tab-area clearfix">
                    <div class="col-md-12 o-no-padding">
                        <ul class="o-tab-view o-tab-view--text">
                            <li><a href="javascript: void(0)" :class="(tab=='basic')?'active':'custom-deactive-btn'" @click="changeTab('basic')">{{ $t('basic_information') }}</a></li>
                            <li><a href="javascript: void(0)" :class="(tab=='skill')?'active':'custom-deactive-btn'" @click="changeTab('skill')">{{ $t('skillset') }}</a></li>
                            <li><a href="javascript: void(0)" :class="(tab=='vacation')?'active':'custom-deactive-btn'" @click="changeTab('vacation')">{{ $t('unavailability') + " & " +$t('vacation') }}</a></li>
                            <!-- v-if="detailEmployee.notes_documents !='disabled'" -->
                            <li><a href="javascript: void(0)" v-if="getNoteAccess()" :class="(tab=='notes')?'active':'custom-deactive-btn'" @click="changeTab('notes')">{{ $t('notes_and_documents') }}  </a></li>
                            <!-- <li><a :class="{active :(tab=='emergency')?true:false}" @click="changeTab('emergency')">Emergency</a></li> -->
                            <li><a href="javascript: void(0)" :class="(tab=='settings')?'active':'custom-deactive-btn'" @click="changeTab('settings')">{{ $t('settings') }}</a></li>
                            <li v-if="userRoleSlug=='auditor'"><a href="javascript: void(0)" :class="(tab=='notes')?'active':'custom-deactive-btn'" @click="changeTab('notes')">{{ $t('notes_and_documents') }} </a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <BasicInformation :empDetails="detailEmployee" v-if="tab=='basic'" />
            <Skills :empDetails="detailEmployee" v-if="tab=='skill'" />
            <Availability :empDetails="detailEmployee" v-if="tab=='vacation'" />
            <Notes :empDetails="detailEmployee" v-if="tab=='notes' && apiStatus" />
            <Emergency :empDetails="detailEmployee" v-if="tab=='emergency'"/>
            <EmployeeSettings :empDetails="detailEmployee" v-if="tab=='settings'" />
            <!-- <employeeNotes :empDetails="detailEmployee" v-show="tab == 'notes'" v-if="apiStatus"/> -->
        </div>
    </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import {
        global
    } from '../../global.js';
    import {
        bus
    } from '../../main';
    import BasicInformation from './employeeBasicDetails';
    import Skills from './employeeSkills';
    import Availability from './availabilityDetails';
    import Emergency from './emergencyDetails';
    import Notes from './employeeNotes';
    import EmployeeSettings from './employeeSettings';
    // import employeeNotes from './employeeNotes';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                clientEmployeeId:'employeeId',
                userRoleSlug: 'userRoleSlug'
            })
        },
        data() {
            return {
                tab: "basic",
                detailEmployee: {},
                getBaseURL: '',
                employeeId:'',
                apiStatus:false,
                employeePhone: []
            }
        },
        methods: {        
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            getNoteAccess(){
              if(this.detailEmployee.notes_documents=='enabled' || this.userRoleSlug=='client-admin' || this.userRoleSlug=='power-user'){
                // console.log('true');
                return true;
              }else{
                // console.log('false');
                return false;
              }
            },
            editEmployee() {
                this.$store.dispatch('setEditEmployeesFrom', 'employeeDetails');
                // this.$router.push({
                //     'path': '/editEmployee'
                // });
                this.$store.dispatch('setEditUserTab', 'personal');
                this.$router.push({
                    'path': '/editEmployee/'+this.$route.params.employeeId
                });
            },
            changeTab: function(newTab) {
                this.tab = newTab;
            },
            backToEmployeeList() {
                this.$router.push({
                    path: `/employees`
                });
            },
            deleteEmployees() {
                this.$confirm('NAME will be removed from the records of CLIENT. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.del('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.$router.push({
                            path: `/employees`
                        });
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },
            getEmpDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                //this.$Progress.start();
                this.apiStatus = false;
                service.get('employee/' + this.employeeId, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((res) => {
                        this.apiStatus = true;
                        this.detailEmployee = res.data.result;
                        let fname = this.detailEmployee&&this.detailEmployee.employable&&this.detailEmployee.employable.first_name?this.detailEmployee.employable.first_name:'Employee Details';
                        let lname = this.detailEmployee&&this.detailEmployee.employable&&this.detailEmployee.employable.last_name?this.detailEmployee.employable.last_name:'';
                        document.title = lname + ', ' + fname;
                        this.employeePhone=res.data.result.employable?res.data.result.employable.phones:[];
                        // console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    // console.log(phone);
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    // console.log(phone);
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
                // return phone;
            },
        },
        beforeMount() {
            this.employeeId=atob(this.$route.params.employeeId);
            this.getEmpDetails();
            bus.$on('onUpdateOrAdd', (data) => {
                //this.personalInfo = data;
                //console.log("Emit fire..", this.employeeId);
                this.getEmpDetails();
            });
        },

        components: {
            'BasicInformation': BasicInformation,
            'Skills': Skills,
            'Availability': Availability,
            'Emergency': Emergency,
            'Notes': Notes,
            'EmployeeSettings':EmployeeSettings,
            // 'employeeNotes':employeeNotes,
        }

    }

</script>

<style scoped>
.employee-summary-profile--inline {
    display: flex!important;
}
.header-value{
    color: #000!important;
    text-transform: capitalize;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/employeeDetails.vue